import { useProvideInject } from '@/composition/provideInject'

const dropdownSymbol = Symbol('tm-dropdown')

export const useInsideDropdown = () => useProvideInject<boolean>(dropdownSymbol)
